import LScreen from "@components/LScreen";
import LText from "@components/LText";

export const ErrorScreen = () => {
  return (
    <LScreen enableAutomaticTopPadding={true} safeArea>
      <LText>Invalid genre</LText>
    </LScreen>
  );
};
